import { Component, OnInit } from '@angular/core';
import { ArkUnitOfWork } from 'app/core/core.module';
import _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-nomination-setting-dialog',
    templateUrl: './nomination-setting-dialog.component.html',
    styleUrls: ['./nomination-setting-dialog.component.scss'],
    standalone: false,
})
export class NominationSettingDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    settings: any;
    requiredDeacons = 4;
    requiredShepherding = 4;
    requiredExecutive = 3;
    formData: any;
    ready = false;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        this.uow.rollback();
        this.formData = {};
        this.settings = await this.uow.getNominationSettings();
        this.requiredDeacons = (_.find(this.settings, { name: 'RequiredDeacons' }) as any).intValue;
        this.requiredExecutive = (_.find(this.settings, { name: 'RequiredExecutiveElders' }) as any).intValue;
        this.requiredShepherding = (_.find(this.settings, { name: 'RequiredShepherdingElders' }) as any).intValue;
        this.ready = true;
    }

    async save() {
        (_.find(this.settings, { name: 'RequiredDeacons' }) as any).intValue = this.requiredDeacons;
        (_.find(this.settings, { name: 'RequiredExecutiveElders' }) as any).intValue = this.requiredExecutive;
        (_.find(this.settings, { name: 'RequiredShepherdingElders' }) as any).intValue = this.requiredShepherding;

        await this.uow.commit();
        this.result.next({ success: true });
    }

    close() {
        this.result.next({ success: false });
    }
}
